import React from 'react'
import {useSelector,useDispatch} from 'react-redux';
import {gameOn,gameOver,startCount,endCount, gameUnPlayed, gamePlayed} from '../actions';

const PlayButton = () => {
    const game = useSelector(state=>state.game);
    const dispatch = useDispatch();
    const startGame=()=>{
        if(game)
        {
            dispatch(endCount);
            dispatch(gameOver);
            dispatch(gamePlayed);
        }
        else
        {
            dispatch(gameUnPlayed);
            dispatch(startCount);
            dispatch(gameOn);
        }
      }
    return (
        <div className="playbutton"  onClick={startGame}>
            {!game&&<span className="secondary"><i className="fas fa-play-circle"></i>&nbsp;Start Game</span>}
            {game&&<span className="secondary"><i className="fas fa-pause-circle"></i>&nbsp;Stop Game</span>}
        </div>
    )
}

export default PlayButton
